import classNames from 'classnames';
import { HistoryWeatherRow, HistoryWeatherRowHeader } from 'components/resort/SnowfallWeatherRow';
import { ISnowfallItem } from 'api/resort/types';
import { AutoScroll } from 'components/blocks/AutoScroll';
import styles from './styles.module.scss';

export const Monthly = (
  { infoMonthly, visible }: { infoMonthly: Array<ISnowfallItem>, visible: boolean },
) => (
  <AutoScroll>
    <section className={classNames(styles.box, visible ? styles.visible : styles.invisible)}>
      <table className={classNames(styles.table)}>
        <HistoryWeatherRowHeader average />
        <tbody>
          {infoMonthly.map((item, index) => (
            <HistoryWeatherRow
              key={item.date}
              snowfall={item}
              className={index % 2 ? '' : styles.other}
            />
          ))}
        </tbody>
      </table>
    </section>
  </AutoScroll>
);
